var metadata = [];
export function setMetadata(targetClass, metadataKey, metadataValue, targetProperty) {
    metadata.push({
        targetClass: targetClass,
        metadataKey: metadataKey,
        metadataValue: metadataValue,
        targetProperty: targetProperty
    });
}
export function getMetadata(targetClass, metadataKey, targetProperty) {
    var targetMetadata = metadata.filter(function (item) { return item.targetClass === targetClass
        && (!metadataKey || item.metadataKey === metadataKey)
        && (!targetProperty || item.targetProperty === targetProperty); });
    var metadataValue = targetMetadata
        ? targetMetadata.map(function (item) { return item.metadataValue; })
        : [];
    var parent = getPrototypeOf(targetClass);
    if (parent) {
        var parentMetadata = getMetadata(parent, metadataKey);
        if (parentMetadata && parentMetadata.length) {
            metadataValue.push.apply(metadataValue, parentMetadata);
        }
    }
    return metadataValue && metadataValue.length ? metadataValue : undefined;
}
export function hasMetadata(targetClass, metadataKey) {
    return !!getMetadata(targetClass, metadataKey);
}
// http://ejohn.org/blog/objectgetprototypeof/
if (typeof Object.getPrototypeOf !== "function") {
    Object.getPrototypeOf = "".__proto__ === String.prototype
        ? function (object) { return object.__proto__; }
        : function (object) { return object.constructor.prototype; };
}
// https://github.com/rbuckton/ReflectDecorators
var functionPrototype = Object.getPrototypeOf(Function);
function getPrototypeOf(obj) {
    var proto = Object.getPrototypeOf(obj);
    if (typeof obj !== "function" || obj === functionPrototype) {
        return proto;
    }
    if (proto !== functionPrototype) {
        return proto;
    }
    var prototype = obj.prototype;
    var prototypeProto = prototype && Object.getPrototypeOf(prototype);
    if (prototypeProto == null || prototypeProto === Object.prototype) {
        return proto;
    }
    var constructor = prototypeProto.constructor;
    if (typeof constructor !== "function") {
        return proto;
    }
    if (constructor === obj) {
        return proto;
    }
    return constructor;
}
//# sourceMappingURL=Metadata.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/metadata/Metadata.js
// module id = 4
// module chunks = 1